// extracted by mini-css-extract-plugin
module.exports = {"container":"stockSalesUpload_container__3RcHL","create":"stockSalesUpload_create__3SU-O"};